import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import styles from './delivery-status.module.scss';
import { colors } from '@/Themes/Colors';
import type { StatusDelivery } from '@/Interfaces/Data';
import { celularLabel, normalizeStatus } from '@/Utils/FnUtils';

interface DeliveryStatusProps {
  deliveryStatus: StatusDelivery;
  deliverymanName?: string;
  deliverymanPhone?: string;
  deliverymanId?: string;
  onCloseModal?: () => void;
}

const COLOR_BY_STATUS: Record<StatusDelivery, string> = {
  ENTREGUE: colors.brandGreen,
  FINALIZADO: colors.brand10,
  PENDENTE: colors.orange10,
  CANCELADO: colors.danger40,
  ASSOCIADO: colors.info40,
  ACEITO: colors.info40,
  CHEGOU_NA_LOJA: colors.info40,
  CHEGOU_NO_CLIENTE: colors.info40,
  SAIU_DA_LOJA: colors.info40,
  PERSONALIZAR_CORRIDA: colors.info40,
};

export const DeliveryStatus = ({
  deliveryStatus,
  deliverymanName,
  deliverymanPhone,
  deliverymanId,
  onCloseModal,
}: DeliveryStatusProps) => {
  const statusFormatted = deliveryStatus
    ? normalizeStatus(deliveryStatus)
    : 'Pendente';

  const deliverymanPhoneLabel = deliverymanPhone
    ? celularLabel(deliverymanPhone)
    : 'não disponível';
  const hasDeliverymanPhone = !!deliverymanPhone;

  return (
    <div className={styles.container}>
      <div className={styles.statusContainer}>
        <span
          style={{
            color: deliveryStatus
              ? COLOR_BY_STATUS[deliveryStatus]
              : colors.brand10,
          }}
        >
          {statusFormatted}
        </span>
      </div>

      <div className={styles.deliveredByContainer}>
        <div>
          <span>Entregador</span>
          {deliverymanName ? (
            <span>
              <Link
                to={`/entregadores/${deliverymanId}`}
                onClick={() => onCloseModal?.()}
              >
                {deliverymanName}
              </Link>
            </span>
          ) : (
            <span>- - -</span>
          )}
        </div>
        <div className={styles.whatsappContainer}>
          <span>Whatsapp entregador</span>
          <span className={styles.whatsappNumberContainer}>
            {hasDeliverymanPhone && (
              <FontAwesomeIcon
                className={styles.whatsappIcon}
                color={colors.brandGreen}
                icon={faWhatsapp}
                aria-label="whatsapp"
              />
            )}
            <span
              className={
                hasDeliverymanPhone
                  ? styles.whatsappNumber
                  : styles.whatsappNumberUnavailable
              }
            >
              {deliverymanPhoneLabel}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
